import { usePublishNode } from "../../pages/devices/hooks/usePublishNode";
import {
  errorNotification,
  successNotification,
} from "../variables/notification";

export type MessageType = {
  TARGET: "MODEL";
  ACTION: "START" | "STOP";
  model_name: string;
  instance_name: string;
  DATA?: {
    serviceType: string;
  };
};

interface IModelActionParameters {
  modelName: string;
  instanceName: string;
  nodeId: string;
  customNotificationMessage?: string;
}

const mqttPublish = () => {
  const { publishNode, loading } = usePublishNode();

  const fetchRequest = (
    message: MessageType,
    nodeId: string,
    customNotificationMessage?: string
  ): Promise<void> =>
    publishNode({
      message: JSON.stringify(message),
      nodeId,
    })
      .then((response): void => {
        if (response.data && customNotificationMessage) {
          successNotification(customNotificationMessage);
        }
      })
      .catch((error): void => {
        errorNotification("Something went wrong when publishing node");

        console.error(error);
      });

  const startModelAction = ({
    modelName,
    instanceName,
    nodeId,
    customNotificationMessage,
  }: IModelActionParameters) =>
    fetchRequest(
      {
        TARGET: "MODEL",
        ACTION: "START",
        model_name: modelName,
        instance_name: instanceName,
        DATA: {
          serviceType: modelName,
        },
      },
      nodeId,
      customNotificationMessage
    );

  const stopModelAction = ({
    modelName,
    instanceName,
    nodeId,
    customNotificationMessage,
  }: IModelActionParameters) => {
    fetchRequest(
      {
        TARGET: "MODEL",
        ACTION: "STOP",
        model_name: modelName,
        instance_name: instanceName,
        DATA: {
          serviceType: modelName,
        },
      },
      nodeId,
      customNotificationMessage
    );
  };

  return {
    startModelAction,
    stopModelAction,
    loading,
  };
};

export default mqttPublish;
